module.exports = __webpack_public_path__ + "img/uid-token-login.394a887a.png";